import {uploadFile} from "../../service/uploaderService/UploaderService";
import {HttpClient} from "../../service/httpClient/HttpClient";

export class FileManagerService {


    constructor() {
        this.httpClient = new HttpClient()
    }

    uploadImageToServer(imageFile, publishStatus, setHideImageUploadLoading, setProgressImage, setBufferImage, fileManagerType) {
        return new Promise((resolve, reject) => {
            uploadFile(
                imageFile,
                setProgressImage,
                setBufferImage,
                setHideImageUploadLoading,
                fileManagerType.uploadUrl,
                {
                    "public-status": publishStatus
                }
            )
                .then(resolve).catch(reject)
        })
    }

    getImages(selectedFileMangerType, page, size = 15) {

        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `buckets/${selectedFileMangerType.id}/files`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    deleteFile(id) {

        return new Promise((resolve, reject) => {
            this.httpClient.delete(
                `files/${id}`,
            ).then(resolve).catch(reject)
        })

    }

    getPublicUrl(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `files/${id}/urls/public`,
            ).then(resolve).catch(reject)
        })
    }

    getFiles(id, page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `buckets/${id}/files`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }


    uploadVideoToServer(file, setUploadPercent, handleHideLoading, url) {
        return new Promise((resolve, reject) => {
            uploadFile(
                file,
                setUploadPercent,
                () => {
                },
                handleHideLoading,
                url,
            ).then(resolve).catch(reject)
        })
    }

    uploadVideo(file, url, setUploadPercent,signal) {
        const options = {
            onUploadProgress: (progressEvent) => {
                const {loaded, total} = progressEvent;
                let percent = Math.floor((loaded * 100) / total)
                setUploadPercent(percent)
            }
        }

        let data = new FormData()
        data.append('file', file)

        return new Promise((resolve, reject) => {
            new HttpClient(options, "multipart/form-data")
                .post(
                    url,
                    data,
                    {},
                    {},
                    signal
                ).then(resolve).catch(reject)
        })
    }


    uploadImageFile(imageFile, handleHideLoading, setUploadPercent, uploadUrl) {
        return new Promise((resolve, reject) => {
            uploadFile(
                imageFile,
                setUploadPercent,
                () => {
                },
                handleHideLoading,
                uploadUrl,
            ).then(resolve).catch(reject)
        })
    }
}